import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useAccountCleanup() {
  const { user } = useAuth();
  const [cleaning, setCleaning] = useState(false);

  const cleanupPlaceholderAccounts = useCallback(async () => {
    if (!user) return false;
    
    setCleaning(true);
    try {
      const { data, error } = await supabase.functions.invoke('cleanup-placeholder-accounts', {
        body: { user_id: user.id }
      });

      if (error) {
        console.error('❌ Error cleaning up accounts:', error);
        toast.error('Failed to clean up accounts');
        return false;
      }

      if (data?.deletedAccounts > 0 || data?.orphanedAccounts > 0) {
        toast.success(`Cleaned up ${data.deletedAccounts + data.orphanedAccounts} incomplete connections`);
      }
      
      return true;
    } catch (error) {
      console.error('❌ Cleanup failed:', error);
      toast.error('Failed to clean up connections');
      return false;
    } finally {
      setCleaning(false);
    }
  }, [user]);

  const checkForPlaceholderAccounts = useCallback(async () => {
    if (!user) return false;
    
    try {
      const { data, error } = await supabase
        .from('social_accounts')
        .select('id')
        .eq('user_id', user.id)
        .or('account_username.like.temp_%,account_username.eq.placeholder,is_active.eq.false');

      if (error) {
        console.error('Error checking for placeholder accounts:', error);
        return false;
      }

      return (data?.length || 0) > 0;
    } catch (error) {
      console.error('Error checking for placeholder accounts:', error);
      return false;
    }
  }, [user]);

  return {
    cleaning,
    cleanupPlaceholderAccounts,
    checkForPlaceholderAccounts
  };
}